import React, { useState } from "react";
import DropAreaInformation from "./DropAreaInformation";
import { trash_can } from "../assets";
import {
  replaceUrl,
  validateEmail,
  validatePhone,
  getLinkedInUsernameRegex,
  getYouTubeUsernameFromUrl,
  getXUsernameFromUrl,
} from "../constants";

const InformationCard = ({ informations, setInformations, Information }) => {
  const AddInformation = (val) => {
    setInformations([
      ...informations,
      {
        ...val,
        value: "",
        options: val.values,
        value_option: val.values ? val.values.split(",")[0] : null,
        validation: true,
      },
    ]);
  };

  const DeleteInformation = (index) => {
    let tempInfo = [...informations];
    tempInfo = tempInfo.filter((info, ind) => ind !== index);
    setInformations(tempInfo);
  };

  const onChangeValue = (e, index, lookup_id = "") => {
    e.preventDefault();
    let tempInfo = [...informations];
    let val;
    if (
      lookup_id == "LKPc6aa04a4b1f5475ca5a752c692f30717" &&
      e.target.value.includes("linkedin.com")
    ) {
      val = getLinkedInUsernameRegex(e.target.value);
    } else if (
      lookup_id == "LKP2f5a4afa91e7431482e9fde30122868c" &&
      e.target.value.includes("youtube.com")
    ) {
      val = getYouTubeUsernameFromUrl(e.target.value);
    } else if (
      lookup_id == "LKP52e4c7bc87fe4d119bb1d1ddd540f54c" &&
      e.target.value.includes("x.com")
    ) {
      val = getXUsernameFromUrl(e.target.value);
    } else {
      val = e.target.value;
    }
    tempInfo[index]["value"] = val;
    tempInfo[index]["validation"] = true;
    setInformations(tempInfo);
  };

  const onBlurValue = (e, index, value, validation) => {
    e.preventDefault();
    let tempInfo = [...informations];
    tempInfo[index]["value"] = value;
    tempInfo[index]["validation"] = validation;
    tempInfo[index]["url"] = replaceUrl(
      value,
      tempInfo[index]["base_url"],
      tempInfo[index]["placeholder"]
    );
    setInformations(tempInfo);
  };

  const updateValidateOnBlur = (e, index, value, validation) => {
    e.preventDefault();
    let tempInfo = [...informations];
    tempInfo[index]["value"] = value;
    tempInfo[index]["validation"] = validation;
    setInformations(tempInfo);
  };

  const onChangeOptions = (e, index) => {
    e.preventDefault();
    let tempInfo = [...informations];
    tempInfo[index]["value_option"] = e.target.value;
    setInformations(tempInfo);
  };

  const [activeInformation, setActiveInformation] = useState(null);

  return (
    <div className="flex flex-col md:flex-row px-5 pt-5 pb-52 md:py-5 gap-10 w-full overflow-y-auto">
      <div className="flex flex-col w-full md:w-1/2 gap-2">
        <DropAreaInformation
          index={0}
          informations={informations}
          setInformations={setInformations}
          activeInformation={activeInformation}
        />
        {informations.map((val, ind) => (
          <>
            <div
              className="flex flex-col gap-2 border rounded-lg px-5 py-3 active:border-black cursor-grab active:cursor-grabbing"
              draggable
              onDragStart={() => setActiveInformation(ind)}
              onDragEnd={() => setActiveInformation(null)}
            >
              <div className="flex flex-row gap-3 ">
                <img
                  src={val.image_url}
                  alt=""
                  className="w-[30px]"
                  draggable={false}
                />
                <input
                  className={`flex flex-col h-[40px] rounded-md border w-full items-center justify-center px-3 ${
                    val.validation ? "" : "border-red-400"
                  }`}
                  value={val.value}
                  onChange={(e) => onChangeValue(e, ind, val.lookup_id)}
                  placeholder={val.placeholder}
                  onBlur={(e) => {
                    let valid = true;
                    if (val.display_label == "E-mail") {
                      valid = validateEmail(val.value);
                    } else if (
                      val.display_label == "Phone" ||
                      val.display_label == "Whatsapp"
                    ) {
                      valid = validatePhone(val.value);
                    }
                    if (val.base_url) {
                      onBlurValue(e, ind, val.value, valid);
                    } else {
                      updateValidateOnBlur(e, ind, val.value, valid);
                    }
                  }}
                />
                <div
                  className="flex flex-col w-1/4 hover:bg-red-300 items-center h-full justify-center rounded-lg text-white cursor-pointer"
                  onClick={() => DeleteInformation(ind)}
                >
                  <img src={trash_can} alt="delete" className="h-[25px]" />
                </div>
              </div>
              {val.options ? (
                <select
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                  onChange={(e) => onChangeOptions(e, ind)}
                >
                  {val.options.split(",").map((val, ind) => (
                    <option value={val} key={ind}>
                      {val}
                    </option>
                  ))}
                </select>
              ) : null}

              {val.base_url ? (
                <input
                  className="flex flex-col h-[40px] rounded-md border w-full items-center justify-center px-3 cursor-not-allowed bg-gray-50"
                  value={val.url}
                  placeholder={val.base_url}
                  disabled={true}
                />
              ) : null}
            </div>

            <DropAreaInformation
              index={ind + 1}
              informations={informations}
              setInformations={setInformations}
              activeInformation={activeInformation}
            />
          </>
        ))}
      </div>
      <div className="flex flex-col w-full md:w-1/2 gap-5">
        {Object.entries(Information).map(([key, value]) => (
          <div className="flex flex-col gap-2">
            <div className="font-bold">{key}</div>
            <div className="grid grid-cols-4 gap-2">
              {value.map((val, ind) => (
                <div
                  key={ind}
                  className="flex flex-col w-full hover:bg-gray-200 cursor-pointer text-center rounded-lg py-3 gap-2 justify-center items-center"
                  onClick={() => AddInformation(val)}
                >
                  <img
                    src={val.image_url}
                    alt={val.display_label}
                    className="w-[30px]"
                  />
                  <div>{val.display_label}</div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InformationCard;
